"use client";
import React, { useEffect, useMemo } from 'react';
import './FormInjures.css';
import PropTypes from 'prop-types';
import { Button, Input, Select, Icon } from 'atm-global-stylish/dist';
import { showModal } from '../../utils/functions';
import PhoneInput from '../basic/PhoneInput/PhoneInput';
import { INPUT_CLASSNAME, SELECT_CLASSNAME } from '../../config/constants';

const acceptImg = ".png, .jpg, .jpeg, .pdf, .doc, .docx";

const FormInjures = ({ injures, lesionado, handleInjured, options_gender, options_bonding, options_injuries, handleChange, maxSize }) => {

	const disabled = useMemo(() => {
		return !(
			lesionado.name !== '' &&
			lesionado.dni !== '' &&
			lesionado.phone !== '' &&
			lesionado.mail !== '' &&
			lesionado.address !== '' &&
			lesionado.detail !== '' &&
			lesionado.name.length >= 3 &&
			lesionado.dni.length >= 8 &&
			lesionado.mail.includes('@') &&
			lesionado.mail.includes('.') &&
			lesionado.address.length >= 3 &&
			lesionado.detail.length >= 3 &&
			lesionado.mail.length >= 5 &&
			lesionado.sex !== '' &&
			lesionado.bonding !== '' &&
			lesionado.level !== '' &&
			lesionado.photo_dni_front !== '' &&
			lesionado.photo_dni_back !== '' &&
			lesionado.photo_medical_certification !== '' &&
			lesionado.photo_additional_6 !== '' &&
			lesionado.photo_police_report !== ''
		);
	}, [lesionado.name, lesionado.dni, lesionado.phone, lesionado.mail, lesionado.address, lesionado.detail, lesionado.sex, lesionado.bonding, lesionado.level, lesionado.photo_dni_back, lesionado.photo_dni_front, lesionado.photo_medical_certification, lesionado.photo_police_report, lesionado.photo_additional_6]);

	const handleClick = () => {

		if (disabled === true) {
			showModal('', 'Debe completar todos los campos obligatorios antes de continuar con la carga del lesionado', 'warning');
		} else {

			handleInjured();
		}
	}

	return (
		<div className='flex flex-col w-full justify-between gap-3 my-10'>
			<p className='text-xl text-red font-semibold text-center'>
				Datos personales lesionado {injures.length + 1 || 1}
			</p>
			<div className='w-full flex-col flex gap-5 items-center justify-center'>
				<div className='flex flex-col md:flex-row w-full items-center justify-center gap-5 md:gap-10'>
					<Select
						list={options_bonding}
						onChange={handleChange('bonding')}
						selectedValue={lesionado.bonding}
						className={`${SELECT_CLASSNAME} text-grey-tx`}
					/>
					<Select
						list={options_gender}
						onChange={handleChange('sex')}
						selectedValue={String(lesionado.sex)}
						className={`${SELECT_CLASSNAME} text-grey-tx`}
					/>
				</div>
				<div className='flex flex-col md:flex-row w-full items-center justify-center gap-5 md:gap-10'>
					<Input className={INPUT_CLASSNAME} type='text' placeholder='Nombre y apellido *' value={lesionado.name} handleChange={handleChange('name')} maxLength={50} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
					<Input className={INPUT_CLASSNAME} type='number' maxLength={8} placeholder='DNI *' value={lesionado.dni} handleChange={(e) => {
						const onlyNumbers = e.target.value.replace(/\D/g, '');

						if (onlyNumbers.length <= 8)
							handleChange('dni')({ target: { value: onlyNumbers } })
						else
							return
					}} />
				</div>
				<div className='flex flex-col md:flex-row w-full items-center justify-center gap-5 md:gap-10'>
					<PhoneInput handleChange={handleChange} prefix={''} className={INPUT_CLASSNAME} />
					<Input className={INPUT_CLASSNAME} type='text' placeholder='Domicilio *' value={lesionado.address} handleChange={handleChange('address')} maxLength={50} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
				</div>
				<div className='flex flex-col md:flex-row w-full items-center justify-center gap-5 md:gap-10'>
					<Input className={INPUT_CLASSNAME} type='email' placeholder='Correo Electronico *' value={lesionado.mail} handleChange={handleChange('mail')} maxLength={100} regex={/^[a-zA-Z0-9@._\-,]*$/} />
					<Select
						list={options_injuries}
						onChange={handleChange('level')}
						selectedValue={String(lesionado.level)}
						className={`${SELECT_CLASSNAME} text-grey-tx`}
					/>
				</div>
				<div className='flex flex-col md:flex-col w-full my-4'>
					<textarea
						className={`border-2 border-pink rounded-lg p-3 w-full h-40 resize-none focus:outline-none ${INPUT_CLASSNAME}`}
						placeholder="Breve descripción de lesiones *"
						onChange={handleChange('detail')}
						value={lesionado.detail}
						maxLength={200}
					/>
				</div>
			</div>
			<p className='text-xl text-red font-semibold text-center mt-10'>
				Toda la documentacion requerida es obligatoria
			</p>
			<p className='text-center font-normal text-base mb-8'>Archivos admitidos son: .png, .jpg, .jpeg, .pdf, .doc, .docx</p>
			<div className='w-full flex-col flex gap-5 md:gap-8 items-center justify-center'>
				<div className='flex flex-col md:flex-row w-full items-center justify-center gap-0 md:gap-12'>
					<FileInput maxSize={maxSize} label={"DNI FRENTE *"} setFile={handleChange('photo_dni_front')} value={lesionado.photo_dni_front} required className='mb-5 md:mb-0'
					/>
					<FileInput maxSize={maxSize} label={"DENUNCIA POLICIAL *"} setFile={handleChange('photo_police_report')} value={lesionado.photo_police_report} required />
				</div>
				<div className='flex flex-col md:flex-row w-full items-center justify-center gap-0 md:gap-12'>
					<FileInput maxSize={maxSize} label={"DNI DORSO *"} setFile={handleChange('photo_dni_back')} value={lesionado.photo_dni_back} required className='mb-5 md:mb-0' />
					<FileInput maxSize={maxSize} label={"CERTIFICADO MEDICO *"} setFile={handleChange('photo_medical_certification')} required value={lesionado.photo_medical_certification} />
				</div>
				<div className='flex flex-col md:flex-row w-full items-center justify-center gap-0 md:gap-12'>
					<div className='flex flex-col md:flex-row w-full items-center justify-center gap-0 md:gap-12'>
						<FileInput maxSize={maxSize} label={"MAS DOCUMENTOS / FOTOS *"} setFile={handleChange('photo_additional_6')} required value={lesionado.photo_additional_6} />
					</div>
				</div>
			</div>
			<p className="text-pink text-sm text-center mb-4">(*) Los campos marcados son obligatorios.</p>
			<div className='w-full md:w-1/3 m-auto mt-6'>
				<Button
					disabled={false}
					handleClick={handleClick}
					type='secondary'
					className='p-2 md:p-3 border-[2px] border-red'
					title='CONFIRMAR LESIONADO'
				/>
			</div>
		</div>
	);
};
const FileInput = ({ label, setFile, value, error, required = false, className = '', maxSize }) => {
	const handleChange = (e) => {
		const file = e?.target?.files[0] ?? null;
		if (file) {
			if (!['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'].includes(file.type)) {
				alert('Formato de archivo no permitido. Solo PNG o JPEG');
			}
		}

		setFile(file);
	}

	return (
		<div className="flex flex-row w-full">
			<Input
				type='file'
				label={label}
				handleChange={handleChange}
				accept={acceptImg}
				inputIcon={value ? <Icon.DoubleCheck size={25} color={'#7C1338'} /> : <Icon.PlusCircle size={25} color={'#7C1338'} />}
				required={required}
				className={`${className} ${error ? 'text-red' : ''} overflow-hidden text-ellipsis text-nowrap md:text-sm text-base`}
				withRemoveButton={required === false}
				maxSize={maxSize}
			/>
		</div>
	);
}
FormInjures.propTypes = {
	handleInjured: PropTypes.func,
	lesionado: PropTypes.object,
	setLesionado: PropTypes.func,
	injures: PropTypes.array,
	setInjures: PropTypes.func,
	disabled: PropTypes.bool
};

export default FormInjures;